import type { Objective } from './api';

// v1: hardcoded. Move to admin-editable config later if needed.
export const HARDCODED_OBJECTIVES: Objective[] = [
  { id: 1, text: 'Maintain compliance and regulatory standing', secondOrder: [] },
  { id: 2, text: 'Protect and grow revenue', secondOrder: [] },
  { id: 3, text: 'Reduce operational cost and improve efficiency', secondOrder: [] },
  { id: 4, text: 'Build solid, functional tech foundations to support growth and scale', secondOrder: [] },
];

export const HARDCODED_COMPANY_CONTEXT = '';
